import { render, staticRenderFns } from "./PlaneChangesView.vue?vue&type=template&id=8a534c8c&scoped=true"
import script from "./PlaneChangesView.vue?vue&type=script&lang=js"
export * from "./PlaneChangesView.vue?vue&type=script&lang=js"
import style0 from "./PlaneChangesView.vue?vue&type=style&index=0&id=8a534c8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a534c8c",
  null
  
)

export default component.exports